import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { StyledTd, StyledTr } from "src/styled";

export interface IAdminShort {
  userid: string;
  firstname: string;
  surname: string;
  email: string;
  phoneno: string;
  mobile: string;
  active: boolean;
  deleted: boolean;
}
interface Props {
  row: IAdminShort;
}

const AdminsRow = ({ row }: Props) => {
  const navigate = useNavigate();
  const handleEditUser = useCallback(
    (userId: string) => {
      navigate(`/management/users/edit-user/${userId}`);
    },
    [navigate],
  );

  return (
    <StyledTr hover onClick={() => handleEditUser(row.userid)}>
      <StyledTd center>{row.firstname}</StyledTd>
      <StyledTd center>{row.surname}</StyledTd>
      <StyledTd center>{row.email}</StyledTd>
      <StyledTd center>{row.phoneno}</StyledTd>
      <StyledTd center>{row.mobile}</StyledTd>
      <StyledTd center>{row.active ? "Yes" : "No"}</StyledTd>
    </StyledTr>
  );
};

export default AdminsRow;
